import React, { useEffect, useState } from "react";
import { getCurrentUser } from "@aws-amplify/auth";
import "./WholisticHealthProgram.css";

export default function WholisticHealthExercise2({ setCurrentView }) {
  const [userId, setUserId] = useState(null);
  const [note, setNote] = useState("");
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    (async () => {
      const u = await getCurrentUser().catch(() => null);
      const uid = u?.attributes?.sub || u?.username || "guest";
      setUserId(uid);
      const raw = localStorage.getItem(`whp-journal-${uid}-ex2`) || "[]";
      try {
        setEntries(JSON.parse(raw));
      } catch (e) {
        setEntries([]);
      }
    })();
  }, []);

  const saveEntry = () => {
    if (!note.trim()) return;
    const e = { text: note.trim(), createdAt: new Date().toISOString() };
    const updated = [e, ...entries];
    setEntries(updated);
    localStorage.setItem(`whp-journal-${userId}-ex2`, JSON.stringify(updated));
    setNote("");
  };

  return (
    <div
      className="whp-container"
      style={{
        width: 350,
        minWidth: 300,
        backgroundColor: "white",
        padding: 5,
        borderRadius: 12,
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        color: "#333",
      }}
    >
      <div style={{ padding: "0 24px" }}>
        <button
          style={{ position: "absolute", left: 16, top: 16 }}
          onClick={() => setCurrentView("WholisticHealthProgram")}
        >
          ← Back
        </button>
        <img
          src={(process.env.PUBLIC_URL || "") + "/Icon-WHP-Blue.png"}
          alt="Logo"
          style={{
            width: "100%",
            maxWidth: 200,
            height: "auto",
            display: "block",
            margin: "20px auto 30px auto",
          }}
        />
        <h1 className="whp-title">Exercise 2</h1>
        <p className="whp-sub">Guided exercise and reflection.</p>
      </div>
      <div style={{ maxWidth: 900, margin: "0 auto 1rem", textAlign: "left" }}>
        <div style={{ aspectRatio: "16/9", width: "100%", marginBottom: 12 }}>
          <iframe
            title="Exercise 2"
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/dpj0SJiiARk"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
        <div style={{ padding: "0 24px" }}>
          <p>
            Watch Exercise 2 above. Use the space below to reflect and journal
            your thoughts after watching and reading the exercise in the{" "}
            <a
              href="https://a.co/d/0fajMzGH"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#0067B3", fontWeight: "600" }}
            >
              Wholistic Health Program © workbook
            </a>
            .
          </p>
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Write your reflection..."
            style={{
              width: "100%",
              minHeight: 120,
              padding: 12,
              borderRadius: 8,
              border: "1px solid #ddd",
            }}
          />
          <div style={{ marginTop: 8, display: "flex", gap: 8 }}>
            <button
              onClick={saveEntry}
              style={{
                background: "var(--primary,#0077cc)",
                color: "#fff",
                padding: "8px 12px",
                borderRadius: 8,
                border: "none",
              }}
            >
              Save Entry
            </button>
            <button
              onClick={() => setNote("")}
              style={{ padding: "8px 12px", borderRadius: 8 }}
            >
              Clear
            </button>
          </div>

          <div style={{ marginTop: 16 }}>
            <h3>Journal Entries</h3>
            {entries.length === 0 && <div>No entries yet.</div>}
            {entries.map((en, i) => (
              <div
                key={i}
                style={{
                  padding: 12,
                  borderRadius: 8,
                  background: "#f9f9f9",
                  border: "1px solid #e0e0e0",
                  marginBottom: 8,
                }}
              >
                <div style={{ fontSize: 12, color: "#666", marginBottom: 6 }}>
                  {new Date(en.createdAt).toLocaleString()}
                </div>
                <div style={{ whiteSpace: "pre-wrap" }}>{en.text}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
